module.exports = __webpack_public_path__ + "img/STERiJECT_05_1.ff96efc3.png";